// Delivery dates: fills every [data-delivery-date] with a date counted from today.
//   data-days="2"             days to add (business days when data-skip-weekends="true")
//   data-days-end="4"         optional end of a range ("12 Oct – 14 Oct")
//   data-cutoff="14"          after this hour, start counting from tomorrow (0 = no cut-off)
//   data-format="month_day"   see FORMATS below
//   data-locale="de"          month names in this language (default: the page language)
//   data-visitor="false"      use the store's date (data-store-now) instead of the visitor's clock
//   data-separator=" – "  data-today-label="Today"
// Used by the Date urgency and Delivery timeline blocks.
(() => {
  if (window.themeDeliveryDates) return;
  window.themeDeliveryDates = true;

  // [order the option promises, Intl options for the localized names/numbers]
  const FORMATS = {
    mm_dd: ['{month}/{day}', { month: '2-digit', day: '2-digit' }],
    dd_mm: ['{day}/{month}', { day: '2-digit', month: '2-digit' }],
    numeric: ['{day}/{month}', { day: 'numeric', month: 'numeric' }],
    month_day: ['{month} {day}', { month: 'long', day: 'numeric' }],
    day_month: ['{day} {month}', { day: 'numeric', month: 'long' }],
    short_month_day: ['{month} {day}', { month: 'short', day: 'numeric' }],
    day_short_month: ['{day} {month}', { day: 'numeric', month: 'short' }],
    month_day_short: ['{month} {day}', { month: 'short', day: 'numeric' }],
    day_month_short: ['{day} {month}', { day: 'numeric', month: 'short' }],
    weekday_month_day: ['{weekday}, {month} {day}', { weekday: 'long', month: 'long', day: 'numeric' }],
    weekday_day_month: ['{weekday} {day} {month}', { weekday: 'long', day: 'numeric', month: 'long' }],
    weekday: ['{weekday}', { weekday: 'long' }],
  };
  const ORDINAL = { month_day_ordinal: ['long', 'month-first'], day_ordinal_month: ['long', 'day-first'], short_month_day_ordinal: ['short', 'month-first'], day_ordinal_short_month: ['short', 'day-first'] };

  const ordinal = (n) => {
    const s = ['th', 'st', 'nd', 'rd'];
    const v = n % 100;
    return n + (s[(v - 20) % 10] || s[v] || s[0]);
  };

  const addDays = (date, days, skipWeekends) => {
    const result = new Date(date);
    if (!skipWeekends) { result.setDate(result.getDate() + days); return result; }
    let left = days;
    while (left > 0) {
      result.setDate(result.getDate() + 1);
      if (result.getDay() !== 0 && result.getDay() !== 6) left -= 1;
    }
    while (result.getDay() === 0 || result.getDay() === 6) result.setDate(result.getDate() + 1);
    return result;
  };

  const format = (date, key, locale) => {
    if (ORDINAL[key]) {
      const [month, order] = ORDINAL[key];
      const name = new Intl.DateTimeFormat(locale, { month }).format(date);
      return order === 'month-first' ? `${name} ${ordinal(date.getDate())}` : `${ordinal(date.getDate())} ${name}`;
    }
    // Names come from the locale (in context, so declined month names stay right); the order from the option.
    const [order, options] = FORMATS[key] || FORMATS.month_day;
    const parts = {};
    new Intl.DateTimeFormat(locale, options).formatToParts(date).forEach(({ type, value }) => { if (!(type in parts)) parts[type] = value; });
    return order.replace(/\{(\w+)\}/g, (_, type) => parts[type] ?? '');
  };

  const fill = (element) => {
    const d = element.dataset;
    let now = new Date();
    if (d.visitor === 'false' && d.storeNow) {
      const [day, hour] = d.storeNow.split(' ');
      now = new Date(`${day}T${String(hour).padStart(2, '0')}:00:00`);
    }
    const skip = d.skipWeekends === 'true';
    const cutoff = Number(d.cutoff) || 0;
    let start = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    if (cutoff > 0 && now.getHours() >= cutoff) start = addDays(start, 1, false);
    let locale = d.locale || document.documentElement.lang || undefined;
    try { Intl.DateTimeFormat.supportedLocalesOf(locale); } catch { locale = document.documentElement.lang || undefined; } // a mistyped language falls back to the page language
    const first = addDays(start, Number(d.days) || 0, skip);
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    let text = d.todayLabel && first.getTime() === today.getTime() ? d.todayLabel : format(first, d.format, locale);
    if (d.daysEnd !== undefined && Number(d.daysEnd) > Number(d.days)) {
      text += (d.separator ?? ' – ') + format(addDays(start, Number(d.daysEnd), skip), d.format, locale);
    }
    element.textContent = text;
  };

  const run = (root = document) => root.querySelectorAll('[data-delivery-date]').forEach(fill);
  run();
  document.addEventListener('shopify:section:load', (event) => run(event.target));
  document.addEventListener('shopify:block:select', () => run());
  document.addEventListener('product:rendered', () => run());
})();
